import { i18n } from '@fs/zion-locale'

export const getUniquePersons = (data) => {
  const uniquePersons = []
  data?.forEach((item) => {
    item?.persons.forEach((person) => {
      if (!uniquePersons.some((uniquePerson) => uniquePerson.memberCisId === person.memberCisId)) {
        if (person?.status !== 'PENDING') uniquePersons.push(person)
      }
    })
  })
  return uniquePersons
}

export const sortAnswersByCompleteDate = (answers) => {
  if (!answers) return []
  return answers?.sort((a, b) => new Date(b.completeDate) - new Date(a.completeDate))
}

export const filterAnswersByActivityGroupIds = (answers, filterGroupItem, cisId) => {
  if (!answers) return []

  // Check if the 'EVERYONE' option is selected
  if (cisId === 'EVERYONE') {
    // If 'EVERYONE' is selected, return all answers without filtering by cisUserId
    if (!filterGroupItem?.activityGroupsIds || filterGroupItem?.activityGroupsIds.length === 0) return answers
    return answers.filter((item) => filterGroupItem?.activityGroupsIds?.includes(item.activityGroupId))
  }

  // Existing filtering logic for specific users
  if (!filterGroupItem?.activityGroupsIds || filterGroupItem?.activityGroupsIds.length === 0)
    return answers.filter((item) => item.cisUserId === cisId)

  return answers.filter((item) => {
    return filterGroupItem?.activityGroupsIds?.includes(item.activityGroupId) && item.cisUserId === cisId
  })
}

export const addFilteringItemAnswerCounts = (answers, filteringGroups, cisId) => {
  if (!answers || !filteringGroups) return []

  // There may be some filtering groups returned that don't actually have any activtyGroupIds assigned - remove them since we can't work with them
  filteringGroups = filteringGroups.filter(
    (item) => item.id === 1 || (item.activityGroupsIds && item.activityGroupsIds.length > 0) // Id 1 is for the 'All' filtering group
  )

  const result = filteringGroups.map((filterItem) => {
    const filteredAnswers = answers.filter((answerItem) => {
      if (!filterItem?.activityGroupsIds || filterItem?.activityGroupsIds.length === 0) {
        return answerItem.cisUserId === cisId
      }
      if (cisId === 'EVERYONE') {
        return filterItem?.activityGroupsIds?.includes(answerItem.activityGroupId)
      }

      return filterItem?.activityGroupsIds?.includes(answerItem.activityGroupId) && answerItem.cisUserId === cisId
    })

    const count =
      cisId === 'EVERYONE' && !filterItem?.activityGroupsIds?.length ? answers.length : filteredAnswers.length

    return { ...filterItem, count }
  })
  return result
}

// Sort the filtering items by count, then by alphabetical order
export const sortFilteringItems = (filteringGroups) => {
  return filteringGroups?.sort((a, b) => {
    if (a.count === b.count) {
      return a.label.localeCompare(b.label)
    }
    return b.count - a.count
  })
}

export const getRelevantFilteringGroups = ({ rawFilteringGroups, allAnswers, selectedPersonCisId }) => {
  let processedFilteringGroups = addFilteringItemAnswerCounts(allAnswers, rawFilteringGroups, selectedPersonCisId)
  processedFilteringGroups = sortFilteringItems(processedFilteringGroups)
  processedFilteringGroups = processedFilteringGroups?.filter((item) => item.count > 0 || item.id === 1) // Remove all filtering groups that don't have any answers
  return processedFilteringGroups
} //

export const getFamilyGroupNames = (familyGroups, familyGroupIds) => {
  if (!familyGroups || !familyGroupIds) return ''

  let returnStr = ''

  const matchingFamilyGroups = familyGroups
    ?.filter((group) => {
      const familyGroupId = group?.familyGroupId ?? group?.id
      const isFound = familyGroupIds?.includes(familyGroupId)
      return isFound
    })
    .sort((a, b) => {
      const nameA = a?.name.toUpperCase()
      const nameB = b?.name.toUpperCase()
      if (nameA < nameB) return -1
      if (nameA > nameB) return 1
      return 0
    })

  if (matchingFamilyGroups?.length === 1) {
    returnStr = i18n.t('story.shared-with-family-group', {
      familyGroupNames: matchingFamilyGroups.map((fg) => fg.name).join(', '),
    })
  }

  if (matchingFamilyGroups?.length > 1) {
    returnStr = i18n.t('story.shared-with-num-family-groups', {
      firstGroupName: matchingFamilyGroups[0]?.name,
      otherCount: matchingFamilyGroups.length - 1,
    })
  }

  return returnStr
}
